import React from "react";
import { Container, Row, Spinner } from "react-bootstrap";
import SubTiltle from "./../Layout/SubTitle";
import CategoryCard from "../Category/CategoryCard";
import UseHomeCategory from "../../CustomHooks/Category/UseHomeCategory";
import UseAllCategory from "../../CustomHooks/Category/UseAllCategory";


const HomeCategory = () => {
  const [searchValue, handleChangeSearchValue, allCategories, loading, pageCount, onPress] = UseAllCategory()
  
  return (
    <Container>
      {loading === false && allCategories && allCategories.length >= 1 ? (<SubTiltle
        title="All Categories"
        btntitle="See More"
        pathlink="/allcategory"
      />) : null}

      <Row className="my-2 d-flex justify-content-between">
        {loading === false ? (
         allCategories &&  allCategories.length >= 1 ? (
            allCategories.slice(0, 4).map((item, index) => {
              let imageUrl = item.image;
              if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
                imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
              }
              else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
                imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/', '');
              }
              else if (imageUrl.startsWith('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/')) {
                imageUrl = imageUrl.replace('http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/http://127.0.0.1:8000/categories/', '');
              }
              else {
                imageUrl = item.image;
              }
              return (
                <CategoryCard
                  key={index}
                  img={imageUrl}
                  title={item.name}
                  id={item._id}
                />
              );
            })
          ) : (
            null
          )
        ) : (
          null)}
      </Row>
    </Container>
  );
};

export default HomeCategory;
